// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8c27c33f","239":"aeb8dc48","453":"e9bb6025","732":"6e2b02c0"}[chunkId] + ".chunk.js";
};